import { render } from "./CustomerOffer.vue?vue&type=template&id=aa8e2260&scoped=true"
import script from "./CustomerOffer.vue?vue&type=script&lang=js"
export * from "./CustomerOffer.vue?vue&type=script&lang=js"

import "./CustomerOffer.vue?vue&type=style&index=0&id=aa8e2260&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa8e2260"]])

export default __exports__